'use client';

import { Theme } from '@radix-ui/themes';
import { useAppSelector } from '@/app/lib/store/hooks';

interface Props {
  children: React.ReactNode;
}

export default function ClientThemeProvider({ children }: Props) {
  const themeMode = useAppSelector(state => state.theme.mode);

  return (
    <Theme
      appearance={themeMode}
      accentColor='jade'
      grayColor='slate'
      radius='full'
      style={{ backgroundColor: 'transparent' }}
    >
      {children}
    </Theme>
  );
}
